import Vue from 'vue'

import axios from 'axios';

import router from '@/router'
import store from '@/store'
import './toaster'

const client = axios.create({
  baseURL: process.env.ROOT_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }/*,
  defaults: {
    withCredentials: true
  }*/
  //timeout: 5000,
});

//client.defaults.withCredentials = true;

client.interceptors.request.use((config) => {

    //console.log('intercception client')

    /*console.log(store.state.login.tempo)
    isRefresh = false
    if (store.state.login.tempo > 0 && store.state.login.tempo <= 1800) {
      console.log("atualiza o token")
      isRefresh = true
      store.state.login.loading = true
    }*/
    store.state.login.loading = true
    if (store.getters['login/isAuthenticated']) {
      config.headers.common['Authorization'] = 'Bearer ' + store.state.login.token
    }
    return config
  }, function (error) {
    store.state.login.loading = false
    return Promise.reject(error)
  }
);

client.interceptors.response.use(async (response) => {
    /*if (isRefresh) {
      try {
        await store.dispatch('login/auth_refresh')
        store.state.login.loading = false
      } catch (e) {
        return false
        store.state.login.loading = false
      }
      store.state.login.loading = false
    }*/
    store.state.login.loading = false
    return response;
  }, (error) => {
    store.state.login.loading = false
    if (error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    } else {
      Vue.prototype.$toaster.error('Sessão expirada. Efetue Login novamente', {timeout: 3000})
      store.dispatch('login/reset_login')
      localStorage.clear()
      router.push({path: '/login'})
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  }
);

export default client




// WEBPACK FOOTER //
// ./src/plugins/axios.js